import clsx from "clsx";
import React, { useState, useEffect } from "react";
import { Menu, MenuItem, Sidebar, SubMenu } from "react-pro-sidebar";
import { useLocation, useNavigate, NavLink } from "react-router-dom";
import {
  AnnouncementIcon,
  BadmintonIcon,
  BookingIcon,
  CorporateIcon,
  CouponIcon,
  DashboardIcon,
  LogoBlack,
  MapIcon,
  PaymentIcon,
  UserIcon,
  logoBlack,
} from "../../constant";
import QuestionMarkButton from "./QuestionMarkButton";
import classes from "./Sidebar.module.css";
import TogglerButton from "./ToggleButton";
import { useSelector } from "react-redux";

const icons = {
  bookings: <BookingIcon size={20} />,
  payments: <PaymentIcon size={20} />,
  dashboard: <DashboardIcon size={20} />,
  locations: <MapIcon size={20} />,
  corporates: <CorporateIcon size={20} />,
  "court-management": <BadmintonIcon />,
  users:<UserIcon size={20} />,
  coupons: <CouponIcon size={20} />,
  "notification-center": <AnnouncementIcon size={20} />,
  "announcements": <AnnouncementIcon size={20} />,
};

const SidebarComponent = ({ children }) => {
  const [collapsed, setCollapsed] = useState(false);
  const [activeItem, setActiveItem] = useState("");
  const location = useLocation();
  const navigate = useNavigate();
  const { menu } = useSelector((state) => state?.auth);

  console.log("menu", menu);
  // Define menu items with their routes

  // Set active item based on current route
  useEffect(() => {
    const currentPath = location.pathname;
    console.log("currentPath", currentPath);
    // Find the menu item that matches the current path
    const currentMenuItem = menu.find((item) => {
      return (
        currentPath === `/${item.router}` ||
        currentPath.startsWith(item.router + "/")
      );
    });

    if (currentMenuItem) {
      setActiveItem(currentMenuItem?.accessID);
    }
  }, [location.pathname]);

  // Handle menu item click
  const handleMenuItemClick = (item) => {
    setActiveItem(item.accessID);
    navigate(`/${item.router}`);
  };

  // Helper function to check if a route is active
  const isRouteActive = (router) => {
    return window.location.pathname.includes(router);
  };

  // Check if user has access to a menu item
  const hasReadAccess = (menuItem) => {
    // if (!menuItem.selectedApplicationAccessControlList) return false;

    // Check if user has read access (accessControlId: 2 is typically for read access)
    return menuItem.selectedApplicationAccessControlList.some(
      (access) => access.accessControlId === 2
    );
  };

  return (
    <>
      <style jsx>
        {`
          .css-18unl23 {
            background-color: var(--primary-color);
          }
          .ps-menu-icon {
            min-width: 23px;
            width: 22px;
          }
          .css-n849r {
            overflow: initial;
          }
          .ps-menu-button.ps-active svg path {
            stroke: var(--primary-color) !important;
          }
        `}
      </style>

      <div style={{ display: "flex", minHeight: "100vh", height: "100%" }}>
        {/* Sidebar */}
        <Sidebar
          width="275px"
          collapsedWidth="106px" // Collapsed width
          className={clsx(classes.mainSidebar, {
            [classes.collapsed]: collapsed,
          })}
          collapsed={collapsed}
          backgroundColor="var(--primary-color)"
          rootStyles={{
            border: "none",
            overflow: "visible",
          }}
        >
          <div
            className={clsx(classes.logoContainer, {
              [classes.collapsedLogo]: collapsed,
            })}
          >
            <img
              src={logoBlack}
              alt="logo"
              className={clsx("img-fluid", classes.logo)}
            />
          </div>
          <TogglerButton onClick={() => setCollapsed((current) => !current)} />

          {/* Menu Items */}
          <div className={classes.menuContainer}>
            <Menu
              className={classes.menuItem}
              menuItemStyles={{
                button: ({ active }) => ({
                  borderRadius: "50px",
                  backgroundColor: active
                    ? "var(--white-color)"
                    : "transparent",
                  color: active ? "var(--primary-color)" : "var(--white-color)",
                  fontFamily: active ? "NotoSans-semiBold" : "NotoSans-regular",
                  fontSize: "14px",
                  "&:hover": active 
                    ? {} // Empty object for active items, so no hover styles are applied
                    : {
                        backgroundColor: "rgba(255, 255, 255, 0.2)",
                        color: "var(--white-color)",
                        fontFamily: "NotoSans-semiBold",
                      },
                  padding: collapsed ? "13px" : "13px 13px",
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  "& svg path": {
                    stroke: active
                      ? "var(--primary-color)"
                      : "var(--white-color)",
                    transition: "stroke 0.3s ease",
                  },
                  "&:hover svg path": active
                    ? {} // Empty object for active items
                    : {
                        stroke: "var(--white-color) !important",
                      },
                }),
              }}
            >
              {menu?.filter((item) => item.router !== "profile").map((item) => {
                if (item.submenu) {
                  return (
                    <SubMenu key={item.id} label={item.title} icon={item.icon}>
                      {item.submenu.map((subItem) => (
                        <MenuItem
                          key={subItem.id}
                          icon={subItem.icon}
                          active={activeItem === subItem.id}
                          onClick={() => handleMenuItemClick(subItem)}
                        >
                          {subItem.title}
                        </MenuItem>
                      ))}
                    </SubMenu>
                  );
                }
                if (item.router) {
                  return (
                    <MenuItem
                      key={item.accessID}
                      icon={icons[item.router]}
                      active={activeItem === item.accessID}
                      onClick={() => handleMenuItemClick(item)}
                    >
                      <span className={classes.menuLabel}>{item.name}</span>
                    </MenuItem>
                  );
                }
                return null;
              })}
            </Menu>
          </div>
        </Sidebar>

        {/* Right-Side Content (Children) */}
        <div style={{ flex: 1 }} className={classes.mainContent}>
          {children}
        </div>
      </div>
    </>
  );
};

export default SidebarComponent;
